import {
  PublisherDomainTtsVoice,
  type PublisherDomainCreatePayload,
  type PublisherDomainListItem,
} from './model';

export const publisherDomainPattern =
  /^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9-]+(\.[a-z]{2,}){1,3}(#?\/?[a-zñáéíóúüA-Z0-9?\\%$#!&_\-{}.*[\]]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;

export interface PublisherDomainFormValue {
  domain: string;
  todayTritonCpm: string;
}

export function createPublisherDomainFormValue(): PublisherDomainFormValue {
  return { domain: '', todayTritonCpm: '' };
}

export function validatePublisherDomainForm(value: PublisherDomainFormValue, showTriton = false) {
  const errors: Partial<Record<keyof PublisherDomainFormValue, string>> = {};
  if (!publisherDomainPattern.test(value.domain.trim())) errors.domain = 'invalid';
  if (showTriton && !isValidTritonCpm(value.todayTritonCpm)) errors.todayTritonCpm = 'invalid';
  return errors;
}

export function serializePublisherDomainCreate(
  publisherId: string,
  raw: PublisherDomainFormValue,
  showTriton = false,
): PublisherDomainCreatePayload {
  return {
    id: { publisherId },
    domain: {
      url: raw.domain.trim(),
      ...(showTriton
        ? { todayTritonCpm: raw.todayTritonCpm.trim() === '' ? null : Number(raw.todayTritonCpm) }
        : {}),
    },
    playlistIds: null,
    immuEnabled: false,
    immuHasContent: false,
    immuEnableMonetization: false,
    immuContentType: null,
    immuAdsPreRoll: false,
    immuAdsMidRoll: false,
    immuAdsPostRoll: false,
    immuAdTag: '',
    scrapingTitleSelector: '',
    scrapingContentSelector: '',
    scrapingImageSelector: '',
    scrapingExcludedSelector: '',
    ttsVoiceType: PublisherDomainTtsVoice.JoannaStandard,
  };
}

export function publisherDomainToFormValue(row: PublisherDomainListItem): PublisherDomainFormValue {
  return { domain: row.url, todayTritonCpm: row.lastTritonCpm?.toString() ?? '' };
}

export function isValidTritonCpm(value: string) {
  return value.trim() === '' || (Number.isFinite(Number(value)) && Number(value) >= 0);
}

export function serializePublisherDomainUpdate(
  row: PublisherDomainListItem,
  value: PublisherDomainFormValue,
  showTriton: boolean,
) {
  if (showTriton && !isValidTritonCpm(value.todayTritonCpm)) throw new Error('Invalid Triton CPM');
  // Preserve the loaded association and hidden IMMU settings, as the legacy PUT does.
  return {
    ...row.source,
    id: row.source.id,
    domain: {
      ...row.source.domain,
      url: value.domain.trim(),
      ...(showTriton
        ? {
            todayTritonCpm:
              value.todayTritonCpm.trim() === '' ? null : Number(value.todayTritonCpm),
          }
        : {}),
    },
  };
}

export type PublisherDomainUpdatePayload = ReturnType<typeof serializePublisherDomainUpdate>;
